
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27.646","height":"26.676","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 452"}},[_c('path',{attrs:{"data-name":"Path 5254","d":"M7.415 9.342l7 6.243 5.366.168-4.648-6.366"}}),_c('path',{attrs:{"data-name":"Path 5255","d":"M9.474 11.181c-2.227-.052-4.925-.115-7.121-.382C-.179 10.492.1 7.82 1.897 7.35c2.157-.562.951-2.739 4.344-3.028 3.511-.491 9.021.463 12.495.791C20.302 3.39 20.898 2.223 22.463.5l4.683.721-3.032 7.538c-1.059 1.916-2.191 2.366-5.347 2.355-.8.027-1.5.051-2.321.075"}}),_c('path',{attrs:{"data-name":"Line 23","d":"M3.186 6.554l2.52.062"}}),_c('path',{attrs:{"data-name":"Path 5256","d":"M7.126 6.706h.2m1.183.067h.2m1.184.068h.2m1.183.067h.2m1.184.068h.2"}}),_c('path',{attrs:{"data-name":"Path 5257","d":"M4.288 18.829h.148a4.684 4.684 0 018.036-1.925 3.953 3.953 0 014.861 3.243 3.487 3.487 0 00-.915 1.611h-.112a2.209 2.209 0 00-2.208 2.209 2.231 2.231 0 00.095.642 3.918 3.918 0 01-.764.074H4.288a2.928 2.928 0 010-5.855z"}}),_c('path',{attrs:{"data-name":"Path 5258","d":"M16.306 21.759h.112a3.534 3.534 0 016.062-1.452 2.977 2.977 0 11.722 5.866h-6.9a2.209 2.209 0 010-4.417z"}})])])
          )
        }
      }
    